<template>
  <section
    v-if="isPageLoaded && news"
    class="related-helps padding_large"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation]"
  >
    <ModuleContainer>
      <header v-if="title" class="module-heading-linked">
        <ModuleHeading>{{ title }}</ModuleHeading>
        <ArchiveLink type="help">Gå til lærerværelset</ArchiveLink>
      </header>
      <section v-if="news && news.length" class="help-list">
        <SinglePost v-for="(article, i) in news" :key="i" :id="article.id" />
      </section>
      <section v-else class="article-list">
        <SinglePost />
        <SinglePost />
        <SinglePost />
      </section>
    </ModuleContainer>
  </section>
</template>

<script>
import ArchiveLink from "@/components/elements/ArchiveLink";
import SinglePost from "@/components/blocks/SingleHelp";

import { mapGetters } from "vuex";

export default {
  name: "related-help",
  props: {
    title: String,
    categories: Array
  },
  computed: {
    ...mapGetters(["getPosts", "isPageLoaded"]),
    news() {
      let posts = this.getPosts(this.categories, "help");
      //exclude
      if(posts && posts.length){
        posts = posts.filter(it => {
          return it.id !== this.currentPage.id;
        });
      }
      

      if (posts && posts.length > 0) {
        let tests = [];
        posts.forEach((post, i) => {
          if (i <= 2) {
            tests.push(post);
          }
        });
        posts = tests;
      }
      return posts;
    }
  },
  components: {
    SinglePost,
    ArchiveLink
  }
};
</script>
<style lang="scss">
.related-helps {
  padding-bottom: 0 !important;
}
</style>
